var React = require('react');

function IconWeb (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"2","y":"5","width":"38","height":"33","rx":"2","stroke":"#00D664","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M2 12H40","stroke":"#00D664","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M16.9993 30.6667L11.666 25.3333L16.9993 20","stroke":"#DDDDDD","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M24.999 20L30.3324 25.3333L24.999 30.6667","stroke":"#DDDDDD","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

IconWeb.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = IconWeb;

IconWeb.default = IconWeb;
